function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/**
 * Given a cue, validates whether the startTime and endTime have been converted to stream positions
 * If they haven't an error is thrown. This is useful in safeguarding that the times have been converted.
 * @param cue
 */ export function validateCueHasPositionsNotDates(cue) {
    if (_instanceof(cue.startTime, Date)) {
        throw new Error('This is not a cue.startTime position');
    }
    if (_instanceof(cue.endTime, Date)) {
        throw new Error('This is not a cue.endTime position');
    }
}
export var byStartTime = function(a, b) {
    var _a_range = _sliced_to_array(a.range, 1), aStartTime = _a_range[0];
    var _b_range = _sliced_to_array(b.range, 1), bStartTime = _b_range[0];
    if (aStartTime < bStartTime) {
        return -1;
    } else if (aStartTime > bStartTime) {
        return 1;
    }
    return 0;
};
export var byEndTime = function(a, b) {
    var aEndTime = a.range[1];
    var bEndTime = b.range[1];
    if (aEndTime < bEndTime) {
        return -1;
    } else if (aEndTime > bEndTime) {
        return 1;
    }
    return byStartTime(a, b);
};
/**
 * Convert an absoluteDate to a stream position (seconds), using the seekableRange as a reference point
 * @param absoluteDate the dateTime corresponding with the stream position
 * @param seekableRange used as a reference point to calculate the stream position
 */ export function calculateStreamPositionFromDate(absoluteDate, playbackTimeline) {
    var _playbackTimeline_seekableRange;
    var positionOfSeekableRangeStart, differenceInMilliseconds;
    if ((_playbackTimeline_seekableRange = playbackTimeline.seekableRange) === null || _playbackTimeline_seekableRange === void 0 ? void 0 : _playbackTimeline_seekableRange.startDate) {
        positionOfSeekableRangeStart = playbackTimeline.seekableRange.start;
        differenceInMilliseconds = absoluteDate.getTime() - playbackTimeline.seekableRange.startDate.getTime();
    } else {
        if (playbackTimeline.absolutePosition) {
            positionOfSeekableRangeStart = playbackTimeline.position;
            differenceInMilliseconds = absoluteDate.getTime() - playbackTimeline.absolutePosition.getTime();
        } else {
            throw new Error('Cannot workout position of date without seekableRange or absolutePosition');
        }
    }
    var position = positionOfSeekableRangeStart + differenceInMilliseconds / 1000;
    return position;
}

//# sourceMappingURL=event-utils.js.map